<div class="card" style="width: 320px; position: absolute; top:12px; right: 20px; z-index: 999;">
  <div class="card-body">
    <div class="d-flex justify-content-between">
      <button class="btn btn-hover-primary w-100 mr-1"
              [ngClass]="{'btn-hover-primary--active' : wizardPreviewState === 'locationMap'}"
              (click)="changeWizardPreviewState('locationMap')">
        <sb-icon icon="locationStreet"></sb-icon>
      </button>
      <button class="btn btn-hover-primary w-100 ml-1"
              [ngClass]="{'btn-hover-primary--active' : wizardPreviewState === 'locationList'}"
              (click)="changeWizardPreviewState('locationList')">
        <sb-icon icon="list"></sb-icon>
      </button>
      <button ngbTooltip="{{'lang.globals.toggleCollapse' | translate}}" placement="top" type="button" container="body"
              class="btn btn-hover-primary ml-2" (click)="this.isCollapsed = !this.isCollapsed;"
              [disabled]="!campaignPreviewData && !commercialPreviewData && ! requirementPreviewData"
              [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
        <sb-icon *ngIf="isCollapsed" icon="chevronDown" class="icon-in-btn"></sb-icon>
        <sb-icon *ngIf="!isCollapsed" icon="chevronUp" class="icon-in-btn"></sb-icon>
      </button>
    </div>
    <div [@smoothCollapse]="isCollapsed ?'initial':'final'">
      <div class="mb-3 mt-3" *ngIf="campaignPreviewData">
        <h6>{{'lang.campaigns.campaignSelection' | translate}}</h6>
        <div class="text-center">
          <sb-icon icon="location"></sb-icon>
          {{campaignPreviewData?.playerAggregation?.locations | sbNumberFormat}}
          /
          <sb-icon icon="screen"></sb-icon>
          {{campaignPreviewData?.playerAggregation?.screens | sbNumberFormat}}
        </div>
      </div>
      <div class="mb-3" *ngIf="commercialPreviewData">
        <h6>{{'lang.campaigns.commercialSelection' | translate}}</h6>
        <div class="text-center">
          <sb-icon icon="location"></sb-icon>
          {{commercialPreviewData?.playerAggregation?.locations | sbNumberFormat}}
          /
          <sb-icon icon="screen"></sb-icon>
          {{commercialPreviewData?.playerAggregation?.screens | sbNumberFormat}}
        </div>
      </div>
      <div class="mb-3" *ngIf="requirementPreviewData">
        <h6>{{'lang.campaigns.requirementSelection' | translate}}</h6>
        <div class="text-center">
          <sb-icon icon="location"></sb-icon>
          {{requirementPreviewData?.playerAggregation?.locations | sbNumberFormat}}
          /
          <sb-icon icon="screen"></sb-icon>
          {{requirementPreviewData?.playerAggregation?.screens | sbNumberFormat}}
        </div>
      </div>
    </div>
  </div>
</div>
